import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';
import moment from 'moment';
import ActionButton from '@/components/action_button/Index.vue';
import LineChart from '@/components/v3/charts/LineChart.vue';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import MetaAdAccounts from '@/plugins/graphql/queries/v3/meta-ad-accounts.gql';
import ToggleCampaign from '@/plugins/graphql/mutations/ads_manager/toggle-campaign.gql';
import MetaCampaignInsights from '@/plugins/graphql/queries/v3/meta-campaign-insights.gql';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import { textTruncate } from '@/helpers/text_truncate';
let CampaignInsights = class CampaignInsights extends Mixins(ViewportSizeMixin, RouterParamsAppMixin, AlertMixin) {
    constructor() {
        super(...arguments);
        this.forceGraphRender = false;
        this.queryOnFlight = false;
        this.adAccounts = [];
        this.insightsData = {
            metaCampaignInsights: [
                {
                    campaignName: '',
                    spend: null,
                    purchaseValue: null,
                    revenue: null,
                    roas: null,
                    costPerClick: null,
                    costPerPurchase: null,
                    contentView: null,
                    addToCartValue: null,
                    impressions: null,
                    costPer1000Impressions: null,
                    clickThroughRate: null,
                    orderCreated: null,
                },
            ],
            totalSpend: null,
            totalPurchase: null,
            totalRevenue: null,
            totalSpendBreakdown: [],
            totalRevenueBreakdown: [],
            next: '',
        };
        this.datePresets = [
            {
                value: 'last_7d',
                text: 'Last 7 Days',
            },
            {
                value: 'last_30d',
                text: 'Last 30 Days',
            },
            {
                value: 'last_90d',
                text: 'Last 90 Days',
            },
            {
                value: 'maximum',
                text: 'Maximum',
            },
        ];
        this.selectedDatePreset = this.datePresets[0];
        this.selectedAdAccount = null;
        this.revenueIcon = require('@/assets/icons/revenue.svg');
        this.adsSpendIcon = require('@/assets/icons/ads-spend.svg');
        this.roasIcon = require('@/assets/icons/roas.svg');
        this.tableHeaders = [
            {
                text: 'On/Off',
                value: 'status',
                align: 'left',
                sortable: false,
            },
            {
                text: 'AD CAMPAIGN NAME',
                value: 'adCampaignName',
                align: 'left',
                sortable: false,
                width: '20%',
            },
            {
                text: 'AD SPEND',
                value: 'adSpend',
                align: 'left',
                sortable: false,
            },
            {
                text: 'PURCHASE VALUE',
                value: 'purchaseValue',
                align: 'left',
                sortable: false,
            },
            {
                text: 'REVENUE',
                value: 'revenue',
                align: 'left',
                sortable: false,
            },
            {
                text: 'ROAS',
                value: 'roas',
                align: 'left',
                sortable: false,
            },
            {
                text: 'Date Start',
                value: 'dateStart',
                align: 'left',
                sortable: false,
            },
            {
                text: 'Date End',
                value: 'dateStop',
                align: 'left',
                sortable: false,
            },
            {
                text: '',
                value: '',
                align: '',
                sortable: false,
            },
            {
                text: '',
                value: 'edit',
                align: 'left',
                sortable: false,
            },
        ];
        this.additionalMobileHeaders = [
            {
                text: 'COST PER CLICK',
                value: 'costPerClick',
                align: 'left',
                sortable: false,
            },
            {
                text: 'COST PER PURCHASE',
                value: 'costPerPurchase',
                align: 'left',
                sortable: false,
            },
            {
                text: 'IMPRESSIONS',
                value: 'impressions',
                align: 'left',
                sortable: false,
            },
            {
                text: 'COST PER 1000 IMPRESSIONS',
                value: 'costPer1000Impressions',
                align: 'left',
                sortable: false,
            },
            {
                text: 'CLICK THROUGH RATE',
                value: 'clickThroughRate',
                align: 'left',
                sortable: false,
            },
        ];
    }
    get itemsPerPage() {
        return this.$route.name === 'ads-manager' ? 10 : 5;
    }
    fetchInsights() {
        this.queryOnFlight = true;
        this.$apollo.queries.insightsData.refetch();
    }
    headerGetter(item) {
        if (item.seeMore) {
            const combinedHeaders = [
                ...this.tableHeaders.slice(0, -1),
                ...this.additionalMobileHeaders,
                this.tableHeaders[this.tableHeaders.length - 1],
            ];
            return combinedHeaders;
        }
        return this.tableHeaders;
    }
    seeMoreToggle(item) {
        if (item.seeMore === undefined) {
            this.$set(item, 'seeMore', true);
        }
        else {
            item.seeMore = !item.seeMore;
        }
    }
    humanReadableDate(date) {
        return moment(date).format('MMM DD YYYY');
    }
    checkStatusValue(item) {
        if (item.status === 'ACTIVE') {
            return true;
        }
        return false;
    }
    toggleCampaign(event, item) {
        const vm = this;
        const variables = {
            input: {
                appUuid: vm.$route.params.appUUID,
                toggle: event,
                campaignId: item.campaignId,
            },
        };
        return this.$apollo
            .mutate({
            mutation: ToggleCampaign,
            variables,
        })
            .then(() => {
            const msg = event ? 'Published' : 'Unpublished';
            this.successNotification(`Campaign Succesfully ${msg}`);
        })
            .catch((e) => {
            this.errorNotification(e.message);
        });
    }
    editableChecker(item) {
        let active = false;
        let validObjective = false;
        if (item.status === 'ACTIVE' || item.status === 'PAUSED') {
            active = true;
        }
        if (item.objective === 'OUTCOME_SALES' || item.objective === 'OUTCOME_TRAFFIC') {
            validObjective = true;
        }
        return active && validObjective;
    }
    editCampaign(item) {
        const vm = this;
        if (this.editableChecker(item)) {
            this.setAdCampaignId(item.campaignId);
            this.setAdAccountId(vm.selectedAdAccount.id);
            this.setAdCampaignObjective(item.objective);
            this.$router.push({
                name: 'edit-ad',
                params: { uuid: this.appUUID, to: 'edit-ad' },
            });
        }
    }
    mounted() {
        if (this.$route.name === 'ads-manager') {
            this.selectedDatePreset = {
                value: 'maximum',
                text: 'Maximum',
            };
        }
    }
};
__decorate([
    Mutation('setAdAccountId')
], CampaignInsights.prototype, "setAdAccountId", void 0);
__decorate([
    Mutation('setAdCampaignId')
], CampaignInsights.prototype, "setAdCampaignId", void 0);
__decorate([
    Mutation('setAdCampaignObjective')
], CampaignInsights.prototype, "setAdCampaignObjective", void 0);
CampaignInsights = __decorate([
    Component({
        components: {
            LineChart,
            ActionButton,
        },
        computed: {
            dataset() {
                this.forceGraphRender = !this.forceGraphRender;
                return {
                    labels: this.insightsData.totalSpendBreakdown.map((item) => item.label),
                    datasets: [
                        {
                            label: 'Revenue',
                            data: this.insightsData.totalRevenueBreakdown.map((item) => item.value),
                            fill: false,
                            borderColor: 'rgba(19, 130, 245, 1)',
                            borderWidth: 6,
                            tension: 0.1,
                        },
                        {
                            label: 'Ads Spend',
                            data: this.insightsData.totalSpendBreakdown.map((item) => item.value),
                            fill: false,
                            borderColor: 'rgba(230, 125, 58, 1)',
                            borderWidth: 6,
                            tension: 0.1,
                        },
                    ],
                };
            },
        },
        apollo: {
            adAccounts: {
                query: MetaAdAccounts,
                variables() {
                    return {
                        appUuid: this.$route.params.appUUID,
                    };
                },
                update(data) {
                    this.queryOnFlight = false;
                    if (data?.adAccounts?.length) {
                        [this.selectedAdAccount] = data.adAccounts;
                    }
                    data.adAccounts.map((adAccount) => {
                        adAccount.name = textTruncate(adAccount.name || '', 13);
                        return adAccount;
                    });
                    return data.adAccounts;
                },
                skip() {
                    return !this.$route.params.appUUID;
                },
            },
            insightsData: {
                query: MetaCampaignInsights,
                variables() {
                    this.queryOnFlight = true;
                    return {
                        appUuid: this.$route.params.appUUID,
                        adAccountId: this.selectedAdAccount.id,
                        datePreset: this.selectedDatePreset.value,
                        objective: this.$route.name === 'ads-manager' ? '' : 'CONVERSIONS',
                    };
                },
                fetchPolicy: 'network-only',
                update(data) {
                    this.queryOnFlight = false;
                    return data.campaignInsights;
                },
                skip() {
                    return !(this.$route.params.appUUID &&
                        this.selectedAdAccount?.id &&
                        this.selectedDatePreset?.value);
                },
            },
        },
    })
], CampaignInsights);
export default CampaignInsights;
